import { FC } from "react";
import "./SearchSourceSkeleton.styles.scss";

interface iSearchSourceSkeletonProps {
	count?: number;
}

const SearchSourceSkeleton: FC<iSearchSourceSkeletonProps> = ({ count = 3 }) => {
	return (
		<>
			{Array.from({ length: count }).map((_, index) => (
				<div key={index} className="SearchSource SearchSourceSkeleton">
					<div className="SearchSource__image">
						<div className="SearchSourceSkeleton__image-placeholder" />
					</div>
					<div className="SearchSource__content">
						<section>
							<div className="SearchSourceSkeleton__title-placeholder" />
							<div className="SearchSourceSkeleton__text-placeholder" />
							<div className="SearchSourceSkeleton__text-placeholder" />
						</section>
						<div className="SearchSource__actions">
							<div className="SearchSourceSkeleton__button-placeholder" />
							<div className="SearchSourceSkeleton__button-placeholder" />
						</div>
					</div>
				</div>
			))}
		</>
	);
};

export default SearchSourceSkeleton; 